import { DateTime } from 'luxon'

export interface GroupUserSearchForm {
    name: string
    userType: string
    perPage: number
    page: number
}

export interface GroupCreateForm {
    name: string
    shortName: string
    description: string
}

export interface GroupUpdateForm {
    name?: string
    shortName?: string
    description?: string
}

export interface GroupUpdateFields {
    name?: string
}

export interface GroupJson {
    id: string
    uuid: string
    name: string
    admin_count: number
    candidate_count: number

    archived_at?: string

    permissions: { can_edit: boolean }
}

declare const GroupIDSymbol: unique symbol
export type GroupID = string & { [GroupIDSymbol]: never }

export class Group {
    id: GroupID
    uuid: string
    name: string
    adminCount: number
    candidateCount: number

    archivedAt?: DateTime | null

    permissions: { canEdit: boolean } = { canEdit: false }

    constructor(
        group: {
            id: string
            uuid: string
            name: string
            admin_count: number
            candidate_count: number
            archived_at?: string
            permissions: { can_edit: boolean }
        },
    ) {
        this.id = group.id as GroupID
        this.uuid = group.uuid
        this.name = group.name
        this.adminCount = group.admin_count
        this.candidateCount = group.candidate_count
        this.archivedAt = group.archived_at ? DateTime.fromISO(group.archived_at) : null
        this.permissions = { canEdit: group.permissions.can_edit }
    }

    static fromJson(json: GroupJson): Group {
        return new Group(json)
    }
}
